import Entity from 'utilities/entity';

class Category extends Entity {

}

export default new Category();